import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "ErrorHandler" */ "./lazyIndex"), { name: "ErrorHandler" });

const lazyInitializeErrorHandlerDevtools: LazyAction<typeof lazyIndex.initializeErrorHandlerDevtools, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeErrorHandlerDevtools);

// only initialize up once per session
let hasInitialized = false;

export async function setupErrorHandler(): Promise<void> {
    if (!hasInitialized &&
        (process.env.NODE_ENV === "dev" ||
            (isGlobalFeatureEnabled("fwk-devTools") && isGlobalFeatureEnabled("fwk-errorpopup")))) {
        await lazyInitializeErrorHandlerDevtools.importAndExecute();
        hasInitialized = true;
    }
}
